module.exports = __webpack_public_path__ + "static/013-0b7db59b24b3b6611c989b9abaaea3dc.jpg";